/* eslint-disable */
import { CommonGet } from '../../../helpers/HttpClient';

export default {
    getFarmerCount,
    getOrderCount,
    GetTodayOrderAssignedFarmerCount,
    GetTodayTransactionCount,
    GetProductForcastForDasboard,
    GetProductDetailsForPieChartDashboard,
    GetProductDetailsHorizontalStackForDasboard,
    GetProductDetailsForRadialGraphInDasboard
};

async function getFarmerCount(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetFarmerCountForDashboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function getOrderCount(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetOrderCountForDashboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetTodayOrderAssignedFarmerCount(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetTodayOrderAssignedFarmerCountForDashboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}
async function GetTodayTransactionCount(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetTodayTransactionCountForDashboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetProductForcastForDasboard(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetProductForcastForDasboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetProductDetailsForPieChartDashboard(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetProductDetailsForPieChartDashboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetProductDetailsHorizontalStackForDasboard(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetProductDetailsForHorizontalStackInDasboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetProductDetailsForRadialGraphInDasboard(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetProductDetailsForRadialGraphInDasboard', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}